import React from 'react';

type Props = {
    displayAreaAddress: string;
};

export const AreaAddress = ({ displayAreaAddress }: Props) => (
    <span className="listing-hero-location">{displayAreaAddress}</span>
);
